module.exports = __webpack_public_path__ + "media/assets/invitation-create-campaign-4f17cf4bc5845dfffe4489683a80a679.svg";